{
	"language": {
		"select": "Dil seçin",
		"sectionTitle": "Dil",
		"changeSuccess": "Dil başarıyla değiştirildi"
	},
	"assistant": {
		"composer": {
			"placeholder": "{{assistantName}} asistanına sorun",
			"disclaimer": "{{assistantName}} hata yapabilir. Önemli bilgileri kontrol edin."
		},
		"greeting": {
			"initialMessage": "👋 Merhaba, ben **{{assistantName}}** öğrenme asistanıyım ve **{{context}}** sınavına daha iyi hazırlanmanıza yardımcı olmak için buradayım! **{{topic}}** hakkında yanıtladığınız soruyu birlikte inceleyelim.",
			"starter": "Merhaba, ben **{{assistantName}}**. Size nasıl yardımcı olabilirim?"
		},
		"chips": {
			"askYourOwn": "Kendi sorunuzu sorun",
			"askFollowUp": "Devam sorusu sorun"
		},
		"emptyState": {
			"title": "{{assistantName}}, yapay zekâ destekli öğrenme asistanınızdır",
			"contextSubtitle": "{{context}} hakkında her şeyi sorun",
			"activateSubtitle": "{{assistantName}}, soruyu yanıtladıktan sonra etkinleşir"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "Hızlı çalışma",
			"examInfo": {
				"subtitle": {
					"setExamDate": "Sınav tarihi belirle",
					"examDateWithValue": "Sınav tarihi: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "Daha iyi olabilir",
				"itsAwesome": "Harika"
			},
			"title": "Tam gaz devam ediyorsunuz!",
			"body": "Çalışmaya gösterdiğiniz özveriyi görmek bizi çok mutlu ediyor! Uygulamayla ilgili deneyiminiz şu ana kadar nasıl? Düşüncelerinizi bir değerlendirmeyle paylaşır mısınız?",
			"cta": "Daha sonra"
		},
		"actions": {
			"studyWeak": "Zayıf alanlara odaklan",
			"viewProgress": "İlerlemenizi görün",
			"seeRank": "Sıranızı kontrol edin",
			"seeRankings": "Lider tablosunu görüntüle",
			"unlock": "Premium içeriğin kilidini aç",
			"unlockTooltip": "Premium içeriğin kilidini açarak özel özelliklere ve ileri düzey çalışma materyallerine erişin",
			"startCustomSession": "Özel oturum oluştur",
			"startCustomSessionTooltip": "Çalışmanızın belirli alanlarına odaklanmak için özel bir çalışma oturumu başlatın",
			"takeDiagnostic": "Tanılama testi çöz",
			"takeDiagnosticTooltip": "Mevcut seviyenizi ölçmek ve çalışma planınızı buna göre uyarlamak için tanılama testi çözün",
			"viewDiagnostic": "Tanılama sonuçlarını görüntüle",
			"viewDiagnosticTooltip": "Güçlü yönlerinizi ve geliştirilecek alanları görmek için tanılama sonuçlarınızı görüntüleyin",
			"viewPodcasts": "Podcast dinle",
			"viewPodcastsTooltip": "Öğrenme deneyiminizi zenginleştirmek için eğitim podcast'lerine erişin",
			"upgradeToPremium": "Premium'a geç",
			"upgradeToPremiumTooltip": "Tüm içerik ve özelliklere erişmek için premium'a yükseltin",
			"extendAccess": "Erişimi uzat",
			"extendAccessTooltip": "Premium içerik ve özelliklere erişiminizi uzatın",
			"setExamDate": "Sınav tarihi belirle",
			"setExamDateTooltip": "İlerlemenizi takip etmek ve sınavınıza hazırlanmak için sınav tarihinizi belirleyin"
		},
		"exam": {
			"daysAgo_one": "{{count}} gün önce",
			"daysAgo_other": "{{count}} gün önce",
			"untilExam_one": "Sınava {{count}} gün kaldı",
			"untilExam_other": "Sınava {{count}} gün kaldı",
			"isToday": "Sınav bugün!"
		},
		"stats": {
			"mastery": "Ustalık",
			"completed_one": "Yanıtlanan öğe",
			"completed_other": "Yanıtlanan öğeler",
			"completedValue": "{{count}}",
			"xpEarned": "Kazanılan XP",
			"xpEarnedValue": "{{value}}",
			"accuracy": "Doğruluk",
			"accuracyValue": "%{{value}}",
			"skillLevelTooltip": "Tahmini {{skill, lowercase}} yeterliğiniz: {{level, lowercase}}",
			"itemsAnsweredTooltip": "Şu ana kadar yanıtladığınız toplam öğe sayısı",
			"responsesAnsweredTooltip": "Şimdiye kadar gönderdiğiniz toplam yanıt sayısı",
			"examDateTooltip": "Sınavınız {{date}} tarihinde",
			"skillCta": {
				"diagnostic": "Tanılama",
				"practice": "Alıştırma yap"
			}
		},
		"menu": {
			"settings": "Ayarlar",
			"profile": "Profil"
		},
		"diagnostics": {
			"title": "Tanılama testleri",
			"free": "Ücretsiz",
			"duration": "{{count}} {{item}} • {{minutes}} dk",
			"completed": "{{count}} {{item}} tamamlandı",
			"start": "Başla",
			"viewReport": "Raporu görüntüle",
			"resume": "Devam et"
		},
		"practiceTests": {
			"title": "Deneme sınavları",
			"sectionalTestsTitle": "Bölüm testleri",
			"diagnosticAssessmentsTitle": "Tanılama değerlendirmeleri",
			"premiumChipTooltip": "{{examName}} sınavı için tam uzunlukta premium deneme sınavları",
			"freeChipTooltip": "{{examName}} sınavı için {{label}}",
			"freeChipTooltipDefault": "{{examName}} sınavı için ücretsiz tanılama değerlendirmeleri",
			"completedDescription_one": "{{count}} öğe • {{date}}",
			"completedDescription_other": "{{count}} öğe • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} öğe • {{timeRemaining}} kaldı",
			"activeDescription_other": "{{attempted}}/{{count}} öğe • {{timeRemaining}} kaldı",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} öğe • {{timeRemaining}} kaldı • Başlangıç: {{startedOn}} • Bitiş: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} öğe • {{timeRemaining}} kaldı • Başlangıç: {{startedOn}} • Bitiş: {{endsOn}}",
			"notStartedDescription_one": "{{count}} öğe • {{duration}}",
			"notStartedDescription_other": "{{count}} öğe • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} öğe • {{duration}} • Bitiş: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} öğe • {{duration}} • Bitiş: {{endsOn}}",
			"viewResultsCta": "Sonuçları görüntüle",
			"startCta": "Başla",
			"chips": {
				"items_one": "{{count}} öğe",
				"items_other": "{{count}} öğe",
				"progress_one": "{{attempted}}/{{count}} öğe",
				"progress_other": "{{attempted}}/{{count}} öğe",
				"timeRemaining": "{{time}} kaldı",
				"startedOn": "Başlangıç: {{date}}",
				"endsOn": "Bitiş: {{date}}",
				"timeLeft": "{{time}} kaldı"
			},
			"status": {
				"notStarted": {
					"label": "Başlanmadı",
					"section": "Tam Uzunlukta Deneme Sınavları"
				},
				"inProgress": {
					"label": "Devam ediyor",
					"section": "Devam ediyor"
				},
				"completed": {
					"label": "Tamamlandı",
					"section": "Tamamlandı"
				},
				"legacyReports": {
					"label": "Eski raporlar",
					"section": "Eski raporlar"
				},
				"migratedReports": {
					"label": "Taşınan raporlar",
					"section": "Taşınan raporlar"
				}
			}
		},
		"skills": {
			"title": "Beceriler",
			"unlockSubtitle": "Alıştırma yapmak için premium kilidini açın",
			"startCta": "Alıştırma yap",
			"freeItemsIncludedChip": "Ücretsiz öğeler dahil",
			"freeItemsAnsweredSubtitle_one": "{{answered, number}}/{{count, number}} ücretsiz öğe yanıtlandı",
			"freeItemsAnsweredSubtitle_other": "{{answered, number}}/{{count, number}} ücretsiz öğe yanıtlandı",
			"progressCards": {
				"questionTypesTitle": "Soru türüne göre performans",
				"questionTypesSubtitle": "{{skill}} soru türlerindeki başarınız",
				"proficiencyTitle": "Yeterliğe göre performans",
				"proficiencySubtitle": "{{skill}} seviyelerindeki ilerlemeniz",
				"questionTypeCardSubtitle": "Yeterlik seviyesine göre ilerleme",
				"bySkillTitle": "Beceriye göre performans",
				"bySkillSubtitle": "Beceriler genelinde toplam ilerleme",
				"needsImprovementTitle": "Geliştirilmesi gerekenler",
				"needsImprovementSubtitle": "Sırada odaklanmanız gereken beceriler",
				"skillPerformanceTitle": "{{skill}} performansı",
				"skillPerformanceSubtitle": "Soru türü ve yeterliğe göre ilerleme",
				"skillLevelSubtitle": "Bu beceri seviyesindeki ilerlemeniz",
				"skillsPerformanceTitle": "Beceri Performansı",
				"performanceByItemDifficulty": "Öğe yeterliğine göre performans",
				"performanceByItemDifficultyCaption_one": "Yanıtladığınız {{count}} öğeye dayanarak doğruluğunuzu yeterlik seviyesine göre gösterir",
				"performanceByItemDifficultyCaption_other": "Yanıtladığınız {{count}} öğeye dayanarak doğruluğunuzu yeterlik seviyesine göre gösterir",
				"questionTypePartSubtitle": "{{skill}} · Bölüm {{part}}",
				"activityGoalTitle": "Etkinlik ve Hedef İlerlemesi",
				"recentActivityTitle": "Son Etkinlikler",
				"goalProgressTitle": "Hedef İlerlemesi",
				"goalProgressSubtitle": "Genel puan · Son 7 hafta",
				"goalProgressInsight": "İstikrarlı biçimde ilerliyorsunuz. Hedefinizin 14 puan altındasınız ve yaklaşık 3 hafta içinde hedefinize ulaşabilirsiniz.",
				"goalProgressActualLabel": "Puanınız",
				"goalProgressTargetLabel": "Hedef",
				"goalProgressTimeAxisLabel": "Zaman",
				"goalProgressScoreAxisLabel": "Genel İlerleme",
				"statusTitle": "Durumunuz",
				"diagnosticsTitle": "Tanılama testleri",
				"diagnosticsReviewCta": "İncele",
				"strengthsFocusTitle": "Güçlü Yönler ve Odak Alanları",
				"strengthsFocusSubtitle": "En güçlü olduğunuz alanlar ve daha fazla alıştırma gerektiren soru türleri",
				"strengthsLabel": "Güçlü Yönler",
				"focusAreasLabel": "Odak Alanları",
				"recommendedNextStepLabel": "Önerilen Sonraki Adım",
				"recommendedNextStepCta": "Başla",
				"practiceTestsViewMore": "{{count}} testin tamamını görüntüle"
			},
			"proficiencySection": "Yeterlik seviyesine göre alıştırma"
		},
		"recommendedTasks": {
			"sectionTitle": "Sizin için önerilenler",
			"startSessionAction": "Pratik yap",
			"resumeAction": "Devam et",
			"reviewResultsAction": "Sonuçları incele",
			"startTestAction": "Teste başla",
			"activeTestBody": "Devam eden değerlendirmenizi tamamlayın",
			"completedTestBody": "Performansınızı ve yanıtlarınızı inceleyin",
			"diagnosticBody": "Sınav formatına alışmak için {{label}} çözün",
			"diagnosticDefaultLabel": "ücretsiz tanılama testi",
			"practiceTestBody": "Süreli bir test ile sınava hazırlık düzeyinizi ölçün.",
			"sectionalTestBody": "{{skills}} becerilerinizi çalışmak için odaklı bir teste girin.",
			"weakSkillTitle": "{{skill}} becerini güçlendir",
			"weakSkillBody": "{{questionType}} alıştırması; henüz hakim olmadığın kısımlara ağırlık verir.",
			"strongSkillTitle": "{{skill}} becerini keskin tut",
			"strongSkillBody": "Burada iyisin. Kısa bir {{questionType}} seti böyle kalmanı sağlar.",
			"mixedSkillTitle": "{{skill}} becerini tamamla",
			"mixedSkillBody": "{{questionTypes}} arasında karışık bir set; kaçırdıklarına ağırlık verir.",
			"higherDifficultySkillTitle": "{{proficiency}} seviyesine çık",
			"higherDifficultySkillBody": "Bu düzeyde {{questionType}} konularını çözdün. Bunlar bir kademe daha zor.",
			"itemsChip_one": "{{count}} öğe",
			"itemsChip_other": "{{count}} öğe",
			"timeRemainingChip": "{{minutes}} dk kaldı",
			"timeRemainingChipCompact": "{{minutes}} dk"
		},
		"itemTypes": {
			"answeredLabel_one": "Yanıtlanan öğe",
			"answeredLabel_other": "Yanıtlanan öğeler",
			"answeredAll": "Tümü",
			"answeredPartial": "{{total}} içinden {{answered}}",
			"cardSubtitleResponses_one": "{{count}} yanıt",
			"cardSubtitleResponses_other": "{{count}} yanıt",
			"responsesLabel_one": "Yanıt",
			"responsesLabel_other": "Yanıt",
			"cardSubtitleComplete": "Tüm öğeler yanıtlandı",
			"cardSubtitlePartial": "{{total}} öğeden {{attempted}} tanesi yanıtlandı",
			"detail": {
				"skillLabel": "Beceri",
				"estimatedLevelLabel": "Tahmini seviye"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} {{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} {{label, lowercase}}",
			"responseCount_one": "{{count, number}} yanıt",
			"responseCount_other": "{{count, number}} yanıt"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "{{count, number}} ücretsiz alıştırma öğesi dahil",
			"freeContentBannerTitle_other": "{{count, number}} ücretsiz alıştırma öğesi dahil",
			"freeContentBannerBody": "{{skills}} öğeleriyle istediğiniz zaman alıştırma yapın. Çalışma Paketi'nin tamamının kilidini açmak için yükseltin.",
			"freeContentBannerCta": "Ücretsiz alıştırmayı başlat"
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "Diğerlerine kıyasla nerede olduğunuzu görün"
		},
		"home": {
			"title": "Ana sayfa"
		},
		"podcasts": {
			"description": "Uzmanların hazırladığı ortopedi podcast'lerini dinleyin."
		},
		"more": {
			"title": "Diğer Ayarlar"
		}
	},
	"emptyState": {
		"progress": {
			"title": "Çalışma ilerlemesi yok",
			"subtitle": "Çalıştıkça ilerlemeniz burada görünecek",
			"cta": "Şimdi çalış"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "Hata",
			"body": "Oturum oluşturulamadı, lütfen tekrar deneyin"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "İleri",
			"highIntermediate": "Orta",
			"intermediate": "Orta",
			"basic": "Temel",
			"none": "Yanıtlanmadı",
			"high": "Ustalaşıldı",
			"medium": "Neredeyse tamam",
			"low": "Geliştirilmeli"
		}
	},
	"leaderboard": {
		"you": "Bu sizsiniz",
		"periods": {
			"all_time": "Tüm zamanlar",
			"month": "Bu ay",
			"week": "Bu hafta"
		},
		"scope": {
			"global": "Genel",
			"friends": "Arkadaşlar"
		},
		"friends": {
			"soon": "YAKINDA",
			"comingSoonTitle": "Arkadaş lider tablosu",
			"comingSoonBadge": "Yakında",
			"comingSoonDescription": "İlerlemenizi arkadaşlarınızla karşılaştırın ve sınıfın zirvesinde kimin olduğunu görün."
		},
		"error": {
			"title": "Bağlantı hatası",
			"description": "Lider tablosu yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
			"tryAgain": "Tekrar dene"
		},
		"empty": {
			"title": "Henüz lider yok",
			"description": "Daha fazla kişi çalıştıkça sıralamalar güncellenir. XP kazanıp zirveyi kapan ilk kişi olun!",
			"startLearning": "Şimdi çalış"
		},
		"topPerformers": "En iyi performans gösterenler",
		"yourPosition": "Sıranız",
		"rankings": "Sıralama",
		"rankingsRange": "Sıralama • #{{startRank}}–{{endRank}}",
		"unranked": {
			"title": "Sıralamaya girmek için XP kazanın!",
			"description": "İlk puanlarınızı kazanmak ve lider tablosuna girmek için bir çalışma oturumu başlatın.",
			"cta": "İlk oturumunuzu başlatın"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "Siz",
		"podium": {
			"first": "1.",
			"second": "2.",
			"third": "3."
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>ile #{{rank}} sırayı geçersiniz</rest>",
			"gapHintFromPodium": "<num>{{value}}</num><unit> XP</unit> <rest>kürsüye uzaklığınız</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "Dersler",
			"searchPlaceholder": "Ders ara",
			"count_one": "{{count}} Ders",
			"count_other": "{{count}} Ders",
			"sortModalTitle": "Dersleri sırala",
			"filterModalTitle": "Konuya göre filtrele",
			"sort": {
				"popularity": "Popülerlik",
				"popularityShort": "Popüler",
				"topic": "Konu",
				"difficulty": "Zorluk",
				"recent": "Son güncellenen",
				"recentShort": "Güncellendi",
				"completed": "Tamamlandı"
			},
			"chips": {
				"all": "Tümü",
				"recent": "Son güncellenen",
				"completed": "Tamamlanan",
				"premium": "Premium",
				"topics": "Konular",
				"topicsCount_one": "{{count}} konu",
				"topicsCount_other": "{{count}} konu"
			},
			"chipTooltips": {
				"all": "Tüm dersleri göster.",
				"recent": "Son güncellenen dersleri göster.",
				"completed": "Tamamlanan dersleri göster.",
				"premium": "Premium dersleri göster.",
				"topics": "Dersleri konuya göre filtrele."
			},
			"filterNames": {
				"premium": "premium",
				"completed": "tamamlanan",
				"topics": "konu"
			},
			"empty": {
				"searchTitle_one": "{{count}} ders arama nedeniyle gizlendi",
				"searchTitle_other": "{{count}} ders arama nedeniyle gizlendi",
				"searchSubtitle": "Farklı anahtar kelimeler deneyin veya aramayı temizleyin",
				"searchCta": "Aramayı temizle",
				"filtersTitle_one": "{{count}} ders filtreler nedeniyle gizlendi",
				"filtersTitle_other": "{{count}} ders filtreler nedeniyle gizlendi",
				"filtersSubtitle_one": "Daha fazlasını görmek için {{filters}} filtresini kaldırın",
				"filtersSubtitle_other": "Daha fazlasını görmek için {{filters}} filtrelerini kaldırın",
				"filtersCta": "Tüm filtreleri temizle",
				"noneTitle": "Ders bulunamadı",
				"noneSubtitle": "Filtreleri kaldırmayı veya yeni bir arama yapmayı deneyin",
				"noneCta": "Tümünü sıfırla"
			}
		},
		"home": {
			"settings": {
				"a11yLabel": "Ayarları aç"
			},
			"continueLearning": {
				"title": "Öğrenmeye devam et"
			},
			"suggested": {
				"title": "Sizin için önerilenler"
			},
			"completed": {
				"title": "Tamamlananlar"
			},
			"all": {
				"title": "Tüm dersler"
			},
			"emptyState": {
				"title": "Henüz ders yok",
				"subtitle": "Yeni dersler için yakında tekrar kontrol edin."
			},
			"card": {
				"resumeCta": "Devam et",
				"progress": "%{{value}} tamamlandı",
				"timeLeft_one": "{{count}} dk kaldı",
				"timeLeft_other": "{{count}} dk kaldı",
				"duration_one": "{{count}} dk",
				"duration_other": "{{count}} dk"
			}
		},
		"overview": {
			"header": {
				"title": "Genel bakış"
			},
			"startCta": "Öğrenmeye başla",
			"objectives": {
				"title": "Öğrenme hedefleri"
			}
		},
		"detail": {
			"takeQuizCta": "Quiz'i çöz",
			"progress": {
				"label": "Modül ilerlemesi"
			},
			"activities": {
				"title": "Etkinlikler",
				"completedCount": "{{total}} üzerinden {{completed}} tamamlandı"
			},
			"artifact": {
				"completed": "Tamamlandı",
				"locked": "Kilitli"
			}
		},
		"stats": {
			"insights": {
				"title": "İlerleme içgörüleri"
			},
			"overallProgress": {
				"title": "Genel ilerleme",
				"completedCount_one": "{{count}} öğeden {{completed}} tanesi tamamlandı",
				"completedCount_other": "{{count}} öğeden {{completed}} tanesi tamamlandı"
			},
			"milestones": {
				"title": "Modül kilometre taşları"
			}
		},
		"studyGuide": {
			"sectionBadge": {
				"label": "Bölüm {{number}}/{{total}}"
			},
			"upNext": {
				"title": "Sıradaki"
			}
		}
	},
	"sessionConfig": {
		"title": "Özel çalışma oturumu",
		"diagnostic": "Tanılama testi",
		"skill": "Beceriler",
		"Proficiency": "Yeterlik",
		"Question Type": "Soru türleri",
		"mastery": "Ustalık",
		"sessionLength": "Oturum süresi",
		"itemsChip_one": "{{count}} öğe",
		"itemsChip_other": "{{count}} öğe",
		"durationEstimate": "{{minutes}} dk",
		"durationRange": "{{min}}–{{max}} dk",
		"noItemsTooltip": "Geçerli filtrelerle eşleşen öğe yok",
		"setCount": "{{count}} {{type}}",
		"dismiss": "Tamam",
		"status": {
			"notAnswered": "Yanıtlanmadı",
			"needsWork": "Geliştirilmeli"
		},
		"itemCount": "{{topics}} genelinde {{count}} öğe tamamlayacaksınız",
		"start": "Oturumu başlat",
		"configuringSession": "Oturum yapılandırılıyor",
		"fetchingContent": "İçerik getiriliyor",
		"preparingMaterials": "Materyaller hazırlanıyor",
		"almostThere": "Neredeyse tamam",
		"startingSession": "Oturum başlatılıyor",
		"playIcon": "play-outline",
		"infoText": "**{{numItems}}** {{itemCount}} tamamlayacaksınız. Bu yaklaşık **{{timeString}}** sürecek.",
		"customSummary": {
			"message": "{{topics}} içinden $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) çalışın.",
			"messageWithMastery": "{{topics}} içinden $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) çalışın ve {{masteryLevels}} $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}}) odaklanın.",
			"messageAllMasteryLevels": "{{topics}} içinden tüm ustalık seviyelerinden $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) çalışın.",
			"itemCount_one": "{{count}} öğe",
			"itemCount_other": "{{count}} öğe",
			"masteryLevelCount_one": "ustalık seviyesine",
			"masteryLevelCount_other": "ustalık seviyelerine",
			"allTopics": "{{count}} konunun tamamı",
			"more": "{{count}} tane daha",
			"quotedMasteryLevel": "“{{masteryLevel}}”"
		},
		"quickStudy": {
			"title": "Hızlı Çalışma",
			"recommended": "Önerilen",
			"custom": "Özel",
			"selectHelper": "Seçmek için bir oturuma dokunun, hazır olduğunuzda başlayın.",
			"emptyRecommended": "Şu anda önerilen oturum bulunmuyor.",
			"summary": "{{skill}} alanından {{count}} öğe çalışın. Tahmini {{minutes}} dakika.",
			"summary_questionType": "{{skill}}, {{questionType}} alanından {{count}} öğe çalışın. Tahmini {{minutes}} dakika.",
			"duration": "{{minutes}} dk",
			"durationSelector": {
				"title": "Süre"
			},
			"levelSessions": {
				"rapidRecall": "Hızlı hatırlama",
				"purposefulPractice": "Amaçlı alıştırma",
				"focusFlow": "Odak akışı",
				"itemsLabel": "{{level}} öğeleri",
				"itemsLabelGeneric": "öğe",
				"summaries": {
					"rapidRecall": "Kapsamınızı istikrarlı biçimde genişletmek için henüz yanıtlamadığınız {{count}} {{level}} öğeyle hızlıca tanışın. Tahmini {{minutes}} dakika.",
					"purposefulPractice": "En çok çalışma gerektiren konulardan başlayarak dengeli bir {{count}} {{level}} öğe setini tamamlayın. Tahmini {{minutes}} dakika.",
					"focusFlow": "Düşük veya orta ustalıkla yanıtladığınız {{count}} {{level}} öğeyle zayıf noktalarınızı güçlendirin. Tahmini {{minutes}} dakika."
				},
				"summariesGeneric": {
					"rapidRecall": "Kapsamınızı istikrarlı biçimde genişletmek için henüz yanıtlamadığınız {{count}} öğeyle hızlıca tanışın. Tahmini {{minutes}} dakika.",
					"purposefulPractice": "En çok çalışma gerektiren konulardan başlayarak dengeli bir {{count}} öğelik seti tamamlayın. Tahmini {{minutes}} dakika.",
					"focusFlow": "Düşük veya orta ustalıkla yanıtladığınız {{count}} öğeyle zayıf noktalarınızı güçlendirin. Tahmini {{minutes}} dakika."
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "Deneyiminizi kişiselleştirmek için bir tanılama testiyle başlayın. Tanılama sonuçlarınız çalışma planınızı oluşturmak için kullanılacaktır."
	},
	"premium": {
		"chip": "Premium",
		"upgrade": "Premium'a yükselt",
		"unlockTitle": "Eksiksiz {{productName}} deneyiminizin kilidini açın",
		"unlockDescription": "Kalan çalışma sürenize göre tasarlanmış kişiselleştirilmiş pratiğin kilidini açın.",
		"readyTitle": "{{date}} tarihindeki sınavınıza hazır olun",
		"tip": "Kişiselleştirilmiş odağınız: Premium, sıradaki pratiği belirler ve geliştikçe çalışma planınızı günceller."
	},
	"purchase": {
		"success": {
			"headerTitle": "Satın aldığınız için teşekkürler!",
			"accessGranted": "{{name}} erişiminiz başarıyla tanımlandı",
			"studyPack": "Çalışma Paketi",
			"practiceTest": "Deneme Sınavı",
			"combo": "Kombo Paket",
			"documentTitle": "Satın alma",
			"summary_one": "Tebrikler! Aşağıdaki **ürünün** kilidi hesabınızda açıldı. {{action}} düğmesine bastıktan sonra uygulamanızın içeriği şu sınavı yansıtacak şekilde değişecek: **{{examName}}**. Farklı bir sınava çalışmak veya başka bir ürün satın almak isterseniz bunu istediğiniz zaman hesap ayarlarınızdan değiştirebilirsiniz.",
			"summary_other": "Tebrikler! Aşağıdaki **{{count}} ürünün** kilidi hesabınızda açıldı. {{action}} düğmesine bastıktan sonra uygulamanızın içeriği şu sınavı yansıtacak şekilde değişecek: **{{examName}}**. Farklı bir sınava çalışmak veya başka bir ürün satın almak isterseniz bunu istediğiniz zaman hesap ayarlarınızdan değiştirebilirsiniz.",
			"unlockedDuration": "Tebrikler! **{{name}}** için **{{duration}}** erişimin kilidini açtınız. Erişiminiz **{{expiry}}** tarihinde sona erecek.",
			"storeNote": "Not: Çalışma Paketlerine yalnızca mobil uygulamalarımızdan erişilebilir. Lütfen cihazınıza uygun uygulamayı indirin.",
			"actions": {
				"goToHome": "Ana sayfaya git",
				"startDiagnostic": "{{label}} başlat",
				"takeDiagnostic": "{{label}} çöz",
				"takeFreeDiagnostic": "Ücretsiz deneme testi çöz",
				"diagnosticLabel": "deneme testi"
			}
		},
		"checkout": {
			"headerTitle": "Satın Alma İşlemini Tamamlayın"
		},
		"paywall": {
			"studyPackDialogTitle": "Çalışma planınızı yükseltin",
			"defaultDialogTitle": "Çalışma planınızı yükseltin",
			"practiceTestDialogTitle": "Deneme sınavlarının kilidini açın",
			"restorePurchaseDialogTitle": "Zaten satın aldınız mı?",
			"restorePurchaseDialogSubheadingWeb": "Yoksa şunu deneyin:",
			"restorePurchaseDialogBody": "Bu ürünü satın aldığınız hâlde hâlâ kilitliyse şunları deneyin:\n\n1. Doğru hesapla giriş yaptığınızdan emin olun\n2. Doğru ürünün seçili olduğundan emin olun\n3. Aboneliğinizin süresinin dolmadığından emin olun\n4. Aboneliğinizi etkinleştirdiğinizden emin olun (gereksiz e-posta klasörünü kontrol edin)\n5. Erişim kodunuz varsa, [erişim kodu]({{baseUrl}}/redeem)\n\nBunların hiçbiri geçerli değilse **buraya tıklayın**",
			"restorePurchaseDialogBodyWeb": "1. Doğru e-posta ile giriş yaptığınızdan emin olun\n2. Doğru **[sınavın seçili olduğundan](/account/settings)** emin olun\n3. Aboneliğinizin süresinin dolmadığından emin olun\n\nBunların hiçbiri geçerli değilse **destek ekibiyle iletişime geçin**",
			"accesDuration": {
				"yearPlan": "**{{duration}}** planı uzatılmış erişim sunar; böylece kendi hızınızda çalışmak ve sınavınıza tam anlamıyla hazırlanmak için azami esnekliğe sahip olursunuz.",
				"moreTime": "Çalışmak için daha fazla zamana ihtiyacınız olacağını düşünüyorsanız **{{duration}}** planını değerlendirebilirsiniz.",
				"otherPlan": "**{{duration}}** planı size **{{expiryText}}** tarihine kadar erişim sağlar; bu da çalışmanız için yeterli zaman demektir. {{moreTime}}"
			},
			"actions": {
				"upgrade": "Yükselt",
				"unlock": "{{price}} karşılığında kilidi aç",
				"subscribe": "{{price}} karşılığında abone ol",
				"extendAccess": "Erişimi uzat",
				"accessHere": "Buradan erişin",
				"redeemAccessCode": "Erişim kodunuz var mı?",
				"restorePurchase": "Zaten satın aldınız mı?",
				"restorePurchaseWeb": "Zaten satın aldınız mı veya erişim kodunuz mu var?"
			},
			"subscriptionSummary": {
				"yearly": "Yıllık abonelik • Otomatik yenilenir • İstediğiniz zaman iptal edin",
				"monthly": "Aylık abonelik • Otomatik yenilenir • İstediğiniz zaman iptal edin",
				"weekly": "Haftalık abonelik • Otomatik yenilenir • İstediğiniz zaman iptal edin",
				"generic": "Otomatik yenilenen abonelik • İstediğiniz zaman iptal edin"
			},
			"planDuration": {
				"day_one": "{{count}} gün",
				"day_other": "{{count}} gün",
				"week_one": "{{count}} hafta",
				"week_other": "{{count}} hafta",
				"month_one": "{{count}} ay",
				"month_other": "{{count}} ay",
				"year_one": "{{count}} yıl",
				"year_other": "{{count}} yıl"
			},
			"recommendedPlan": {
				"plan": "**{{date}}** tarihindeki sınavınıza en iyi şekilde hazırlanmanız için **{{duration}}** planını öneriyoruz",
				"subscription": {
					"yearly": "Kesintisiz erişim ve **{{date}}** tarihindeki sınavınıza hazırlık için **yıllık aboneliği** öneriyoruz",
					"monthly": "Kesintisiz erişim ve **{{date}}** tarihindeki sınavınıza hazırlık için **aylık aboneliği** öneriyoruz",
					"weekly": "Kesintisiz erişim ve **{{date}}** tarihindeki sınavınıza hazırlık için **haftalık aboneliği** öneriyoruz",
					"generic": "Kesintisiz erişim ve **{{date}}** tarihindeki sınavınıza hazırlık için bir **abonelik** öneriyoruz"
				}
			},
			"disclaimer": "Satın alma işleminiz onaylandığında, seçtiğiniz süre boyunca bu ürünün içeriğine tam erişim kazanırsınız. Bu süre dolduğunda kısıtlı içeriğe erişiminiz sona erer. Herhangi bir nedenle (örneğin sınav tarihinizi değiştirdiyseniz) erişiminizi uzatmak isterseniz, ek uygulama içi satın alımlarla süre ekleyebilirsiniz. Daha fazla bilgi için [Hizmet Şartları ve Gizlilik Politikamıza](https://memorang.com/legal) bakın."
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "{{count}} {{type}} genelinde yanıtlanan {{numItems}} {{item}} temel alınmıştır",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "Bu, {{count}} {{type}} genelindeki ilerlemenizi gösterir. Şu ana kadar yanıtladığınız {{itemCount}} {{item}} temel alınmıştır."
		},
		"needsImprovement": {
			"title": "Geliştirilmesi gerekenler",
			"subtitle": "Geliştirmeniz için önerilen {{type}}",
			"cta": "Şimdi çalış"
		},
		"mastery": {
			"high": "Ustalaşıldı",
			"medium": "Neredeyse tamam",
			"low": "Geliştirilmeli",
			"count": "{{count}} {{item}} yanıtlandı",
			"zeroTooltip": "Yanıtlanan {{total}} öğe içinde henüz {{label}} öğe yok",
			"highTooltip": "Yanıtlanan {{total}} {{item}} içinden {{count}} tanesinde ustalaştınız",
			"mediumTooltip": "Yanıtlanan {{total}} {{item}} içinden {{count}} tanesinde ilerleme kaydediyorsunuz",
			"lowTooltip": "Yanıtlanan {{total}} {{item}} içinden {{count}} tanesinde daha fazla alıştırmaya ihtiyacınız var"
		},
		"stats": {
			"completion": "Tamamlanma",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "{{total}} {{item}} içinden {{completed}} tanesini tamamladınız"
		},
		"exams": {
			"title": "Deneme sınavları",
			"subtitle_one": "Tamamlanan {{count}} değerlendirme temel alınmıştır",
			"subtitle_other": "Tamamlanan {{count}} değerlendirme temel alınmıştır"
		},
		"summary": {
			"title": "Öğrenme özeti",
			"subtitle": "Yanıtlanan {{count}} {{item}} temel alınmıştır",
			"tooltip": "Bu özet, toplam {{count}} {{item}} genelindeki ustalık seviyelerinizi ve tamamlanma ilerlemenizi gösterir. Performansınız alıştırma oturumları, değerlendirmeler ve çalışma etkinlikleriyle ölçülür.",
			"mastery": "Ustalık",
			"quickStats": "Hızlı istatistikler"
		},
		"languageLearning": {
			"proficiencyCardTitle": "{{skill}} yeterliği",
			"proficiencyCardTooltip": "Şu anda {{skill, lowercase}} alanında {{level, lowercase}} seviyesinde performans gösteriyorsunuz",
			"itemTypesCardSubtitle_one": "{{count}} öğe türü",
			"itemTypesCardSubtitle_other": "{{count}} öğe türü",
			"itemTypesCardTitle": "{{skill}} öğeleri",
			"itemTypeLevelTooltip": "“{{itemType}}” soru türlerinde şu anda {{skill, lowercase}} alanında {{level, lowercase}} seviyesinde performans gösteriyorsunuz",
			"itemTypesFallbackTitle": "Öğe türleri",
			"itemTypesEmptyTitle": "Öğe türleri kullanılamıyor",
			"itemTypesEmptySubtitle": "Bu beceri için öğe türü bulamadık. İlerleme ekranına dönüp tekrar deneyin.",
			"itemTypesEmptyCta": "İlerlemeye dön",
			"notAnswered": "Yanıtlanmadı",
			"answeredSubtitle_one": "Yanıtlanan {{count}} öğe temel alınmıştır",
			"answeredSubtitle_other": "Yanıtlanan {{count}} öğe temel alınmıştır",
			"responsesSubtitle_one": "{{count}} yanıta göre",
			"responsesSubtitle_other": "{{count}} yanıta göre",
			"testsTakenSubtitle_one": "Girilen {{count}} test temel alınmıştır",
			"testsTakenSubtitle_other": "Girilen {{count}} test temel alınmıştır",
			"startFirstTest": {
				"title": "Hadi başlayalım",
				"itemsSubtitle_one": "{{count}} soru",
				"itemsSubtitle_other": "{{count}} soru",
				"guidance": {
					"diagnostic": "Güçlü yönlerinizi belirlemek ve çalışma planınızı uyarlamak için bir tanı testiyle başlayın.",
					"sectional": "Bölüm testi sınavın tek bir bölümüne odaklanır; böylece daha kısa bir oturumda puan alırsınız.",
					"fullMock": "Tam deneme sınavı gerçek sınavı baştan sona yansıtır ve en eksiksiz puanı verir."
				}
			},
			"noScoresTitle": "Henüz {{skill, lowercase}} puanınız yok",
			"noScoresSubtitle": "Tahmini puanınızı ve görev dökümünüzü görmek için ilk testinizi çözün.",
			"noScoresCta": "Başla",
			"noScoresCardSubtitle": "Girdiğiniz testlere göre",
			"personalBestLabel": "Kişisel rekorunuz",
			"latestLabel": "En son sonucunuz",
			"examCountdown_one": "Sınavınıza {{count}} gün var",
			"examCountdown_other": "Sınavınıza {{count}} gün var",
			"greeting": {
				"none": "Hadi başlayalım, {{firstName}}! 🚀",
				"low": "İyi bir başlangıç, {{firstName}} — devam edin! 💪",
				"medium": "Böyle devam, {{firstName}}! 💪",
				"high": "Neredeyse geldiniz, {{firstName}}! 🎯"
			},
			"greetingNoName": {
				"none": "Hadi başlayalım! 🚀",
				"low": "İyi bir başlangıç — devam edin! 💪",
				"medium": "Böyle devam! 💪",
				"high": "Neredeyse geldiniz! 🎯"
			},
			"stats": {
				"untilExam": "Sınav tarihi",
				"itemsAnswered": "Yanıtlanan öğeler",
				"responsesAnswered": "Yanıtlar"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "Geçersiz erişim kodu",
		"incorrectPassword": "Parola yanlış. Lütfen tekrar deneyin.",
		"passwordPlaceholder": "Parolayı girin",
		"emailPlaceholder": "örn., dave@gmail.com",
		"verify": {
			"openEmail": "Devam etmek için e-postayı açın",
			"signInCta": "Hesabınız doğrulanıyor...",
			"signUpCta": "Hesabınız oluşturuluyor...",
			"contactSupport": "E-postayı göremiyor musunuz? Spam klasörünüzü kontrol edin veya",
			"contactSupportLink": "Bize ulaşın",
			"resendMagicLink": "Sihirli bağlantıyı tekrar gönder",
			"resendMagicLinkIn": "Sihirli bağlantıyı {{time}} içinde tekrar gönder",
			"signInBody": "Neredeyse tamam! {{appName}} uygulamasına güvenli şekilde giriş yapmanız için bilgileriniz doğrulanıyor.",
			"signUpBody": "Neredeyse bitti! Yeni {{appName}} uygulama hesabınızı oluşturmak için bilgilerinizi doğruluyoruz.",
			"magicLinkEmail": "**{{email}}** adresine sihirli bir bağlantı gönderdik\nGüvenli şekilde giriş yapmak için e-postanızdaki bağlantıya tıklayın.",
			"magicLinkEmailExpiry": "Bu bağlantının süresi 10 dakika içinde dolar",
			"confirmEmail": "E-postanızı onaylayın",
			"redirectingToApp": "{{appName}} uygulamasına yönlendiriliyor...",
			"appNotOpen": "Uygulama açılmadı mı? İlgili uygulamayı açmak için aşağıdaki düğmeye tıklayın",
			"openApp": "{{appName}} uygulamasını aç",
			"installAppPrompt": "Hiçbir şey olmazsa {{appName}} uygulamasının cihazınızda yüklü olduğundan emin olun",
			"verifyAccountTitle": "Hesabınızı doğrulayın",
			"emailResent": "Sihirli bağlantı {{email}} adresine gönderildi\nLütfen spam klasörü dahil gelen kutunuzu kontrol edin.",
			"verificationLinkExpired": "Doğrulama bağlantısının süresi doldu",
			"verificationLinkExpiredBody": "Doğrulama bağlantılarının süresi 10 dakika sonra dolar ve yalnızca bir kez kullanılabilir. \nTekrar giriş yaparak yeni bir bağlantı isteyebilirsiniz",
			"accountSetupTimeoutTitle": "Giriş işlemi tamamlanamadı",
			"accountSetupTimeoutBody": "Hesabınızın kurulumu beklenenden uzun sürüyor. Lütfen tekrar giriş yapmayı deneyin, sorun devam ederse destek ekibiyle iletişime geçin.",
			"loginAgain": "Tekrar giriş yap",
			"contactSupportExpiredLink": "Bu sorun devam ederse bize bildirin",
			"successTitle": "Artık başka bir sekmede oturum açtınız",
			"successBody": "Bu sekmeyi kapatın veya buradan devam edin",
			"successCtaLabel": "Buradan devam et",
			"needHelpLabel": "Yardıma mı ihtiyacınız var?",
			"contactSupportButton": "Bize ulaşın"
		},
		"contactSupportDialog": {
			"title": "Giriş yaparken sorun mu yaşıyorsunuz?",
			"body": "Giriş yaparken sorun yaşıyorsanız lütfen müşteri destek ekibimizle iletişime geçin veya tekrar deneyin",
			"cta": "Bize E-posta Gönderin"
		},
		"emailInstruction": {
			"default": "E-posta almazsanız önemsiz, spam ve son silinenler klasörlerini kontrol edin",
			"edu": "E-posta almazsanız önemsiz, spam ve son silinenler klasörlerini kontrol edin veya BT yöneticinizle iletişime geçin"
		},
		"createSessionLoader": {
			"configuringSession": "Oturum yapılandırılıyor",
			"analyzingMastery": "Ustalık analiz ediliyor",
			"loadingContent": "İçerik yükleniyor"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "Size nasıl hitap edelim?",
				"description": "Kullanıcı adınız herkese açık lider tablolarında görünür, adınız ise gizli kalır.",
				"usernameLabel": "Kullanıcı adı",
				"firstNameLabel": "Ad",
				"lastNameLabel": "Soyad",
				"avatarLabel": "Avatar",
				"avatarTooltip": "Avatarlar kullanıcı adınıza göre otomatik olarak oluşturulur.",
				"profileSaveFailed": "Profiliniz kaydedilemedi. Lütfen tekrar deneyin."
			},
			"testDate": {
				"cta": "Devam et"
			},
			"examDate": {
				"daysAway": "Bu bize {{value}} gün kazandırıyor. En zayıf alanlarınıza hemen öncelik vereceğiz."
			},
			"skills": {
				"chooseAll": "Geçerli olanların tümünü seçin"
			},
			"plan": {
				"recommended": "Önerilen"
			},
			"toeicLevelOverview": {
				"title": "Herkes bir yerden başlar.",
				"description": "Pratik, doğal olarak bir sonraki seviyeye geçmeden önce bulunduğunuz seviyede ustalaşmanıza yardımcı olur.",
				"illustrationLabel": "Temel (A1–A2) seviyesinden Orta (B1–B2) ve Yetkin (C1) seviyesine ilerleme.",
				"levels": {
					"basic": {
						"name": "Temel",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "Orta",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "Yetkin",
						"band": "C1"
					}
				},
				"progression": {
					"title": "Nasıl ilerleyeceksiniz",
					"practiceSessions": "Önerilen oturumlarla pratik yapın",
					"buildMastery": "Mevcut seviyenizde ustalık kazanın",
					"growToward": "Yetkin seviyesine doğru gelişmeye devam edin"
				},
				"levelDetails": {
					"title": "Her seviyenin anlamı",
					"scoreRange": "{{band}} · puan {{min}}–{{max}}",
					"basic": {
						"name": "Temel Kullanıcı",
						"summary": "İş yerinde basit İngilizce",
						"examples": {
							"forms": "Formlar ve bildirimler",
							"instructions": "Talimatlar",
							"announcements": "Kısa duyurular"
						}
					},
					"intermediate": {
						"name": "Orta Düzey Kullanıcı",
						"summary": "İş yerinde günlük iletişim",
						"examples": {
							"emails": "E-postalar ve konuşmalar",
							"customers": "Müşteri etkileşimleri",
							"followUps": "Toplantı takipleri"
						}
					},
					"proficient": {
						"name": "Yetkin Kullanıcı",
						"summary": "Profesyonel ve ileri düzey İngilizce",
						"examples": {
							"reports": "Karmaşık raporlar ve sunumlar",
							"negotiations": "İncelikli müzakereler",
							"highStakes": "Yüksek riskli profesyonel bağlamlar"
						}
					}
				},
				"disclaimer": "TOEIC Link puanları, CEFR ile uyumlu yol gösterici değerlerdir; mutlak geçme puanları değildir. Reading ve Listening bağımsız ilerler — her beceride farklı seviyelere ulaşabilirsiniz."
			},
			"review": {
				"diagnosticChoice": {
					"title": "Tanılama testi: {{title}}",
					"body": "Nereye odaklanacağınızı belirlemek için {{count}} öğe",
					"duration": "{{minutes}} dk"
				},
				"homeChoice": {
					"title": "Kendim keşfedeyim",
					"body": "Başlamaya hazır değilim, önce uygulamayı keşfedeceğim"
				}
			}
		},
		"common": {
			"changeLater": "Bunu daha sonra değiştirebilirsiniz"
		},
		"actions": {
			"previous": "Önceki",
			"finish": "Bitir",
			"start": "Başla",
			"continue": "Devam et",
			"stepIndicator": "Adım {{step}}/{{total}}"
		}
	},
	"more": {
		"profile": {
			"title": "Hakkınızda"
		},
		"exam": {
			"title": "Sınavınız"
		},
		"subscriptions": {
			"title": "Ürünler",
			"redeem": {
				"title": "Satın alma kodunu kullan"
			},
			"extend": {
				"cta": "Uzat"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "Hedef sınav tarihinizi belirleyin",
			"description": "Bu tarih yalnızca uygulama içindeki çalışma programınıza yön vermek içindir. Resmi sınav kaydınızı etkilemez.",
			"dismissCta": "Şimdi değil",
			"confirmCta": "Sınav tarihi belirle"
		}
	},
	"account": {
		"title": "Hesap ayarları",
		"currentExam": "Mevcut sınav",
		"subscriptions": "Ürünler",
		"examDate": "Sınav tarihi",
		"examDateUpdated": "Sınav tarihi {{date}} olarak ayarlandı",
		"selectDate": "Tarih seçin",
		"appearance": "Görünüm",
		"features": "Özellikler",
		"audioPlaybackTest": "Ses oynatma testi iletişim kutusunu göster",
		"theme": "Tema",
		"selectTheme": "Tema seçin",
		"themeOptions": {
			"system": "Sistem",
			"light": "Açık",
			"dark": "Koyu"
		},
		"accountInfo": "Hesap",
		"username": "Kullanıcı adı",
		"name": "Ad",
		"nameNotSet": "Ayarlanmadı",
		"save": "Kaydet",
		"editUsername": {
			"title": "Kullanıcı adını düzenle"
		},
		"editName": {
			"title": "Adı düzenle"
		},
		"email": "E-posta",
		"dev": "Geliştirici",
		"sandbox": "Test ortamı",
		"redoOnboarding": "Tanıtımı tekrarla",
		"about": "Hakkında",
		"termsOfService": "Hizmet şartları",
		"privacyPolicy": "Gizlilik politikası",
		"aiToolsTos": "Yapay zekâ araçları kullanım şartları",
		"support": "Destek",
		"supportEmailBody": "Size ulaşıyorum çünkü şu konuda yardıma ihtiyacım var: [  ]\n\n\n\nSorunun daha hızlı çözülmesine yardımcı olacak bazı bilgiler: \n\nHesapla ilişkili kullanıcı adı (uygulamaya giriş yaptığınızda ayarlarda bulunur):\n{{username}}\n\nSiparişimle ilişkili e-posta (uygulamaya giriş yaptığınızda ayarlarda bulunur):\n{{email}}\n\nSipariş Numarası (genellikle satın alma sonrası gönderilen makbuz e-postasında bulunur):\n\nÜrün satın alınırken farklı bir ad veya e-posta kullanılmış olabilir mi? Öyleyse lütfen belirtin:\n\nAd ve soyad:\n\nE-posta:",
		"contactSupport": "Destek ekibiyle iletişime geç",
		"signOut": "Çıkış yap",
		"signOutConfirmation": "Çıkış yapmak istediğinizden emin misiniz?",
		"deleteAccount": "Hesabı sil",
		"platform": "Platform",
		"partnerships": "İş birlikleri",
		"validUntil": "{{date}} tarihinde sona erer",
		"extendValidity": "Erişimi uzat",
		"redeemPurchase": "Satın alımı kullan",
		"redeemPurchaseNoneFound": "Kullanılabilecek satın alım yok",
		"redeemPurchaseCheckFailed": "Satın alımlar kontrol edilemedi. Lütfen tekrar deneyin.",
		"purchases": "Satın alımlar",
		"frequentlyAskedQuestions": "Sık sorulan sorular",
		"deleteFeedbackForm": {
			"placeholder": "Geri bildirim"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "Daha fazla veri gerekli",
		"proficiencyLevelPendingTooltip": "Seviyenizi tahmin etmek için daha fazla {{label}} öğesi yanıtlayın",
		"on": "tarihinde",
		"gotIt": "Anladım",
		"goBack": "Geri dön",
		"topic": "konu",
		"itemCount_one": "{{count}} öğe",
		"itemCount_other": "{{count}} öğe",
		"examCount_one": "{{count}} sınav",
		"examCount_other": "{{count}} sınav",
		"questionCount_one": "{{count}} soru",
		"questionCount_other": "{{count}} soru",
		"item_one": "öğe",
		"item_other": "öğe",
		"and": "ve",
		"this": "bu",
		"of": "/",
		"knowMore": "Daha fazla bilgi",
		"proficiency": "yeterlik",
		"didNotAnswer": "Henüz yanıtlamadığınız öğeler",
		"notAnswered": "Yanıtlanmadı",
		"attempted": "denendi",
		"attempt": "deneme",
		"activity": "etkinlik",
		"performance": "Performans",
		"estimatedProficiency": "Tahmini yeterlik",
		"details": "ayrıntılar",
		"keepPracticing": "alıştırmaya devam edin!",
		"leaveFeedback": "Geri bildirim bırak",
		"copiedToClipboard": "Panoya kopyalandı",
		"eg": "örn.",
		"set": "belirle",
		"hint": "ipucu",
		"itemType": "öğe türü",
		"minute": "dakika",
		"minutes": "{{count}} dakika",
		"hour": "saat",
		"hours": "{{count}} saat",
		"continue": "Devam et",
		"unlock": "Kilidini aç",
		"cancel": "İptal",
		"view": "Görüntüle",
		"switch": "Değiştir",
		"update": "Güncelle",
		"ok": "Tamam",
		"yes": "Evet",
		"free": "Ücretsiz",
		"answered": "Yanıtlandı",
		"correct": "Doğru",
		"incorrect": "Yanlış",
		"marked": "İşaretlendi",
		"unmarked": "İşaretlenmedi",
		"skipped": "Atlandı",
		"skill_one": "beceri",
		"skill_other": "beceri",
		"word_one": "kelime",
		"word_other": "kelime",
		"submitResponse": "Yanıtı gönder",
		"viewDetails": "Ayrıntıları görüntüle",
		"sec_one": "sn",
		"sec_other": "sn",
		"point_one": "puan",
		"point_other": "puan",
		"week": "Hafta",
		"month": "Ay",
		"year": "Yıl",
		"day": "Gün",
		"selectTestDate": "Sınav tarihi seçin",
		"points": "Puan",
		"viewAll": "Tümünü görüntüle",
		"timeline": "Zaman çizelgesi",
		"save": "Kaydet",
		"filters": {
			"selectAll": "Tümünü seç",
			"deselectAll": "Seçimi kaldır",
			"selectedCount": "{{count}} seçildi",
			"expandSection": "{{section}} bölümünü genişlet",
			"collapseSection": "{{section}} bölümünü daralt"
		},
		"showMore": "Daha fazla göster",
		"showLess": "Daha az göster",
		"expandA11yLabel": "Açıklamayı genişlet",
		"collapseA11yLabel": "Açıklamayı daralt",
		"done": "Bitti",
		"clearAll": "Tümünü temizle",
		"clear": "Temizle",
		"datePicker": {
			"title": "Tarih seç",
			"enterDateLabel": "Tarih girin",
			"enterDateRangeLabel": "Tarihleri girin",
			"dateLabel": "Tarih",
			"startDateLabel": "Başlangıç tarihi",
			"endDateLabel": "Bitiş tarihi",
			"dateRequiredError": "Tarih gereklidir",
			"invalidDateFormatError": "Geçersiz tarih biçimi. Lütfen MM/DD/YYYY kullanın",
			"startAfterEndError": "Başlangıç tarihi bitiş tarihinden sonra olamaz",
			"endBeforeStartError": "Bitiş tarihi başlangıç tarihinden önce olamaz",
			"minDateError": "Tarih {{date}} veya sonrası olmalıdır",
			"maxDateError": "Tarih {{date}} veya öncesi olmalıdır",
			"dateRangeError": "Tarih {{startDate}} ile {{endDate}} arasında olmalıdır",
			"setDateCta": "Tarihi ayarla",
			"nextCta": "İleri",
			"setTimeCta": "Saati ayarla"
		}
	},
	"session": {
		"choicePercentageTooltip": "Öğrenenlerin {{percentage}} kadarı bu cevabı seçti.",
		"choiceCorrectA11yLabel": "Doğru cevap",
		"choiceIncorrectA11yLabel": "Yanlış cevap",
		"choiceNotSelectedA11yLabel": "Seçilmedi",
		"moreItemsAlertDialog": {
			"title": "Ek Öğeler",
			"cta": "Anladım"
		},
		"results": {
			"followUps": {
				"title": "Devam soruları"
			},
			"summary": {
				"sessionAnalysis": "Oturum Analizi",
				"itemCount_one": "{{count}} öğe",
				"itemCount_other": "{{count}} öğe",
				"skilledItemCount_one": "{{count}} {{skills}} öğesi",
				"skilledItemCount_other": "{{count}} {{skills}} öğesi",
				"levelPhrase_one": "{{levels}} seviyesinden",
				"levelPhrase_other": "{{levels}} seviyelerinden",
				"message": "<bold>Harika iş!</bold> {{timeTaken}} içinde {{itemPhrase}} tamamladınız.",
				"messageWithLevels": "<bold>Harika iş!</bold> {{timeTaken}} içinde $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}) {{itemPhrase}} tamamladınız.",
				"proficiencyEstimateReady": "Tahmini {{skill}} seviyeniz: <bold>{{currentLevel}}</bold>. Artık <bold>{{nextLevel}}</bold> seviyesini hedeflemeye hazırsınız.",
				"proficiencyEstimateKeepPracticing": "Tahmini {{skill}} seviyeniz: <bold>{{currentLevel}}</bold>. <bold>{{nextLevel}}</bold> seviyesine geçmeden önce alıştırmaya devam edin.",
				"proficiencyEstimateHighest": "Tahmini {{skill}} seviyeniz: <bold>{{currentLevel}}</bold>. Muhteşem bir performans!",
				"mixedLevel": "Karışık",
				"overallScore": "Genel Puan",
				"stats": {
					"itemsAttempted_one": "Yanıtlanan öğe",
					"itemsAttempted_other": "Yanıtlanan öğeler",
					"pointsEarned_one": "Kazanılan puan",
					"pointsEarned_other": "Kazanılan puan",
					"answeredCorrectly": "Doğru yanıtlanan",
					"timeTaken": "Geçen süre",
					"target": "Hedef",
					"ofTotal": "/ {{total}}",
					"ofPointsTotal": "/ {{total}}",
					"skill": "Beceri",
					"skills": "Beceriler",
					"questionType": "Soru türü",
					"questionTypes": "Soru türleri",
					"proficiencyLevel": "Yeterlik seviyesi",
					"proficiencyLevels": "Yeterlik seviyeleri"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "Ses {{seconds}} sn içinde başlıyor",
			"audioStartsInPlayOnce": "Ses {{seconds}} sn içinde başlıyor, yalnızca bir kez oynatılır",
			"videoStartsIn": "Video {{seconds}} sn içinde başlıyor",
			"videoStartsInPlayOnce": "Video {{seconds}} sn içinde başlıyor, yalnızca bir kez oynatılır",
			"recordingIn": "Kayıt {{seconds}} sn içinde başlıyor"
		},
		"timeOverrunBanner": {
			"message": "Süre doldu. Gerçek sınavda bundan sonrası puanlanmazdı. Alıştırmaya devam edebilirsiniz."
		},
		"attributes": {
			"stimulus": "uyaran"
		},
		"stimulusTypes": {
			"reading": "Okuma",
			"listening": "Dinleme",
			"speaking": "Konuşma",
			"writing": "Yazma",
			"image": "Görsel"
		},
		"masteryLevels": {
			"belowBasic": "Temel Altı",
			"basic": "Temel",
			"belowLowIntermediate": "Alt Orta Altı",
			"lowIntermediate": "Alt Orta",
			"highIntermediate": "Üst Orta",
			"advanced": "İleri",
			"proficiencySubtitle": "{{trademark}} sınavında bu, **{{minScore}}-{{maxScore}}/30** puana karşılık gelir",
			"infoSectionLabel": "{{skill}} bölümü bilgisi",
			"infoSectionText": {
				"Reading": "{{trademark}} Okuma bölümü, akademik ortamda kullanılan yazılı materyalleri ne kadar iyi okuyup anladığınızı ölçer. Her biri yaklaşık 700 kelimelik iki okuma parçası ve parça başına 10 soru içerir. Okuma bölümünü tamamlamak yaklaşık 35 dakika sürer.",
				"Listening": "{{trademark}} Dinleme bölümü, İngilizce konuşmaları ve dersleri anlama becerinizi ölçmek için tasarlanmıştır. Temel kavrama, konuşmacının tutumunu ve kesinlik derecesini anlama ve bilgileri ilişkilendirme gibi dinleme becerilerini kapsar. Dinleme bölümünü tamamlamak yaklaşık 36 dakika sürer.",
				"Speaking": "{{trademark}} Konuşma bölümü, akademik ortamlarda İngilizceyi etkili biçimde konuşma becerinizi ölçer. Dört soru/görev, sınıf içinde ve dışında karşılaşabileceğiniz gerçek yaşam durumlarına benzer. Konuşma bölümünü tamamlamak yaklaşık 16 dakika sürer.",
				"Writing": "{{trademark}} Yazma bölümü, akademik bir ortamda İngilizce yazma ve fikirlerinizi açık, düzenli biçimde sunma becerinizi ölçer. Yanıtlarınızı bilgisayar klavyesinde yazacaksınız ve Yazma bölümünü tamamlamak yaklaşık 29 dakika sürer."
			}
		},
		"itemTypes": {
			"MCSS": "Çoktan seçmeli, tek yanıt",
			"MCSSH": "Çoktan seçmeli, tek yanıt vurgulamalı",
			"MCMS": "Çoktan seçmeli, çok yanıtlı",
			"MCMSH": "Çoktan seçmeli, çok yanıtlı vurgulamalı",
			"INSERT_TEXT": "Metin ekleme",
			"MATCH_MS": "Çok yanıtlı eşleştirme",
			"MCSSM": "Çoktan seçmeli, tek yanıtlı eşleştirme",
			"MCMSM": "Çoktan seçmeli, çok yanıtlı eşleştirme",
			"MCGS": "Çoktan seçmeli boşluk doldurma",
			"MCOS": "Çoktan seçmeli sıralama",
			"LISTENING_REPLAY": "Dinleme tekrarı",
			"AUDIO_INPUT": "Sesli yanıt",
			"ACADEMIC_DISCUSSION_RESPONSE": "Akademik tartışma yanıtı",
			"INTEGRATED_WRITING_RESPONSE": "Bütünleşik yazma yanıtı"
		},
		"passageStem": {
			"itemOfTotal": "Öğe {{current}}/{{total}}",
			"questionOfTotal": "Soru {{current}}/{{total}}",
			"stimulusCorrespondsToNextItems": "Aşağıdaki uyaran, sonraki {{total}} öğeyle ilgilidir",
			"passage": "Parça",
			"lecture": "Ders",
			"professorsQuestion": "Profesörün Sorusu",
			"listen": "Dinle",
			"openPassage": "Parçayı aç",
			"backToItem": "Öğeye dön",
			"notYetInserted": "Henüz eklenmedi",
			"insertedAtPosition": "#{{position}} konumuna eklendi"
		},
		"hint": {
			"show": "İpucunu göster"
		},
		"navigation": {
			"next": "İleri",
			"exit": "Çıkış",
			"saveAndExit": "Kaydet ve çık",
			"previous": "Geri",
			"skip": "Atla",
			"finish": "Bitir",
			"help": "Yardım",
			"about": "Soru ipuçları",
			"questionsButtonLabel": "Soru gezinmesi",
			"questionsButtonTooltip": "Herhangi bir soruya atlayın veya işaretlediklerinizi inceleyin",
			"questionsButtonActiveFiltersA11y": "Etkin filtreler: {{count}}",
			"recordingInProgressTooltip": "Kayıt sürerken bu öğeden ayrılamazsınız",
			"questionNotReachedTooltip": "Bu soruya henüz ulaşmadınız"
		},
		"questionTips": {
			"hideFutureLabel": "İpuçlarını otomatik gösterme"
		},
		"toolbar": {
			"calculatorTooltip": "Hesap makinesini aç",
			"highlightTooltip": "Kolay başvuru için önemli bilgileri vurgulamak üzere metni seçin",
			"markTooltip": "Göndermeden önce tekrar dönmek için bu soruyu işaretleyin",
			"unmarkTooltip": "Bu sorunun işaretini kaldırmak için tıklayın"
		},
		"summary": {
			"viewFullInsights": "Tüm içgörüleri görüntüle",
			"targetTooltip": "Bu oturum için performans hedefi."
		},
		"stats": {
			"skill": "Beceri",
			"answered": "Yanıtlandı",
			"speed": "Hız",
			"duration": "Süre",
			"duration_tooltip": "Kaydettiğiniz yanıtın uzunluğu: {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "Güven",
			"pointsEarned": "Puan",
			"word": "Kelime",
			"words": "Kelime",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "Bu öğeyi okuyup yanıtlamanız {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) sürdü",
			"skill_tooltip": "Bu öğe için değerlendirilen beceri alanı: {{skill}}",
			"answered_correct_tooltip": "Gönderdiğiniz yanıt doğruydu",
			"answered_incorrect_tooltip": "Gönderdiğiniz yanıt yanlıştı",
			"skipped_tooltip": "Bu öğe için yanıt göndermediniz",
			"words_tooltip": "Yazılı yanıtınızdaki kelime sayısı: {{count}}",
			"word_tooltip": "Yazılı yanıtınızdaki kelime sayısı: {{count}}",
			"confidence_tooltip": "Yanıtınızı gönderirken ne kadar emin olduğunuz",
			"points_earned_tooltip_one": "Bu öğe için en fazla {{maximumScore}} puandan {{points}} puan kazandınız",
			"points_earned_tooltip_other": "Bu öğe için en fazla {{maximumScore}} puandan {{points}} puan kazandınız",
			"challengers_tooltip": "Bu öğeyi sizden önce yanıtlayan öğrenci sayısı: {{count}}",
			"learning_mode_points_tooltip": "Bu deneme için kazanılan puan: +{{xp}} XP",
			"pts_earned_tooltip": "Bu deneme için kazanılan puan: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "Dağılımı genişlet"
		},
		"explanation": {
			"title": "Açıklama",
			"feedback": "Geri bildirim",
			"skippedFeedbackNotice": "Bu soruyu atladığınız için kişiselleştirilmiş geri bildirim oluşturulmadı."
		},
		"followUps": "Devam soruları",
		"suggestCorrection": "Düzeltme öner",
		"answer": {
			"correct": "Doğru",
			"incorrect": "Yanlış",
			"skipped": "Atlandı"
		},
		"confidence": {
			"high": "Yüksek",
			"medium": "Orta",
			"low": "Düşük"
		},
		"endDialog": {
			"title": "Oturum erken bitirilsin mi?",
			"confirmEndDiagnostic": "Oturumunuzu bitirmek istediğinizden emin misiniz? Tüm ilerleme kaybolacak ve baştan başlamanız gerekecek.",
			"confirmEnd": "Hâlâ {{num}} {{itemLabel}} kaldı. Şimdi bitirebilir veya tamamlamak için çalışmaya devam edebilirsiniz.",
			"confirmEndNoAnswer": "Henüz hiçbir soruyu yanıtlamadınız. Şimdi bitirmek istediğinizden emin misiniz?",
			"confirmEndNoAnswerPositive": "Çalışmaya devam et",
			"confirmEndNoAnswerNegative": "Şimdi bitir"
		},
		"permissionDialog": {
			"title": "Mikrofon erişimi gerekli",
			"descriptionWeb": "Konuşma alıştırması mikrofonunuzu kullanır. Tarayıcınız bu site için erişimi engelliyor — web adresinin yanındaki izin simgesine tıklayın, mikrofona izin verin ve tekrar deneyin.",
			"descriptionMobile": "Konuşma alıştırması mikrofonunuzu kullanır. Devam etmek için cihaz ayarlarınızdan mikrofon erişimine izin verin.",
			"promptDescriptionWeb": "Konuşma alıştırması mikrofonunuzu kullanır. İzin isteyin ve tarayıcınız sorduğunda İzin ver'i seçin.",
			"blockedDescriptionWeb": "Bu site için mikrofon erişimi engellendi. Web adresinin yanındaki simgeye tıklayın, mikrofona izin verin ve ardından yeniden izin isteyin.",
			"ok": "Tamam",
			"cancel": "İptal",
			"openSettings": "Ayarları aç",
			"requestPermission": "İzin iste",
			"dismissAndExit": "Kapat ve çık",
			"learnMore": "Daha fazla bilgi"
		},
		"audioPlaybackTestDialog": {
			"title": "Ses oynatmayı test edin",
			"description": "{{appName}} uygulaması; uyaranlar, test öğeleri ve metin okuma gibi birçok ses oynatma özelliği içerir. En iyi deneyimi yaşamanız için lütfen aşağıdan sesinizi test edin. Çalıştığını doğruladıktan sonra devam edin.",
			"troubleshooting": {
				"title": "Ses sorunlarını giderme",
				"volumeTitle": "Cihaz sesini kontrol edin",
				"volumeDescriptionWeb": "Ses düzeyini klavye tuşlarıyla veya menü/görev çubuğundaki sistem ses ayarlarıyla ayarlayın",
				"volumeDescriptionMobile": "Cihazın ses düğmelerini kullanın veya sistem ayarlarından düzenleyin",
				"outputTitle": "Ses çıkış cihazını doğrulayın",
				"outputDescription": "Kulaklık kullanıyorsanız düzgün bağlandığından ve etkin çıkış cihazı olarak seçildiğinden emin olun",
				"browserTitle": "Tarayıcı sekmesi sesini kontrol edin",
				"browserDescription": "Sekme başlığının yanında sessize alınmış hoparlör simgesi olup olmadığına bakın ve varsa sesi açın."
			},
			"skipCheck": "Bu kontrolü bir dahaki sefere atla",
			"workingButton": "Sesi onayla",
			"textToHear": "Şunu duymalısınız: {{text}}"
		},
		"overall": "Genel",
		"subskills": {
			"content": {
				"title": "İçerik"
			},
			"languageUse": {
				"title": "Dil Kullanımı"
			},
			"organizationAndDevelopment": {
				"title": "Düzen ve Geliştirme"
			},
			"topicDevelopment": {
				"title": "Konu Geliştirme"
			},
			"delivery": {
				"title": "Sunum"
			}
		},
		"finalizing": {
			"title": "Sonuçlarınız hazırlanıyor",
			"gradingProgress": "Yanıtlar puanlanıyor..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "Öğrencinin duyduğu cümleyi olabildiğince doğru şekilde tekrarladığı bir konuşma görevi.",
			"Read Aloud": "Öğrencinin bir metni değerlendirilmek üzere sesli okuduğu bir konuşma sorusu.",
			"Describe Image": "Öğrencinin bir görseli ayrıntılı olarak betimlediği bir konuşma görevi.",
			"Write Essay": "Verilen konu hakkında yapılandırılmış bir kompozisyon yazmayı gerektiren açık uçlu bir görev.",
			"Retell Lecture": "Öğrencinin dinlediği bir ders veya konuşmayı özetlediği bir konuşma görevi.",
			"Summarize Group Discussion": "Öğrencinin birden çok konuşmacının yer aldığı bir tartışmayı özetlediği bir dinleme görevi.",
			"Answer Short Question": "Tek bir kısa soruya öz bir yanıt verilen kısa bir konuşma görevi.",
			"Respond to a Situation": "Öğrencinin tanımlanan bir duruma uygun şekilde yanıt verdiği bir konuşma görevi.",
			"Summarize Written Text": "Öğrencinin bir metni kendi sözcükleriyle özetlediği bir okuma görevi.",
			"Reorder Paragraph": "Öğrencinin karışık paragrafları doğru sıraya dizdiği bir okuma görevi.",
			"Fill in the Blanks (Dropdown)": "Her boşluğun açılır listedeki seçeneklerden doldurulduğu bir okuma görevi.",
			"Fill in the Blanks (Type In)": "Öğrencinin eksik kelimeyi veya kısa ifadeyi yazdığı bir dinleme görevi.",
			"Fill in the Blanks (Drag and Drop)": "Eksik kelimelerin seçenekleri boşluklara sürükleyerek doldurulduğu bir okuma görevi.",
			"Multiple Choice, Single Answer": "Öğrencinin tek bir doğru yanıtı seçtiği çoktan seçmeli bir soru.",
			"Multiple Choice, Single Answer (Reading)": "Öğrencinin tek bir doğru yanıtı seçtiği çoktan seçmeli bir okuma sorusu.",
			"Multiple Choice, Single Answer (Listening)": "Öğrencinin tek bir doğru yanıtı seçtiği çoktan seçmeli bir dinleme sorusu.",
			"Multiple Choice, Multiple Answers": "Öğrencinin birden fazla doğru yanıt seçebildiği bir soru.",
			"Multiple Choice, Multiple Answers (Reading)": "Öğrencinin birden fazla doğru yanıt seçebildiği bir okuma sorusu.",
			"Multiple Choice, Multiple Answers (Listening)": "Öğrencinin birden fazla doğru yanıt seçebildiği bir dinleme sorusu.",
			"Summarize Spoken Text": "Öğrencinin duyduklarının özetini yazdığı bir dinleme görevi.",
			"Highlight Correct Summary": "Öğrencinin sese en uygun özeti işaretlediği bir dinleme görevi.",
			"Select Missing Word": "Öğrencinin eksik kelimeyi seçtiği boşluk doldurma tarzı bir dinleme görevi.",
			"Highlight Incorrect Words": "Öğrencinin transkriptte sesten farklı olan kelimeleri işaretlediği bir dinleme görevi.",
			"Write from Dictation": "Öğrencinin duyduğu cümleyi yazıya döktüğü bir dinleme görevi."
		}
	},
	"report": {
		"readFullInsights": "Tüm içgörüleri oku",
		"productName": "{{examName}} {{type}}",
		"startedAt": "Başlangıç: {{time}}",
		"itemTypesTitle": "Öğe türü dağılımı",
		"itemTypesFilterAll": "Tümü",
		"questionTypeCardTitle": "{{skill}} öğe türü dağılımı",
		"questionTypeCardSubtitle_one": "Bu oturumdaki {{count}} {{skill}} öğe türü temel alınmıştır",
		"questionTypeCardSubtitle_other": "Bu oturumdaki {{count}} {{skill}} öğe türü temel alınmıştır",
		"questionTypeCardAltSubtitle_one": "Bu oturumdaki {{count}} öğe türü temel alınmıştır",
		"questionTypeCardAltSubtitle_other": "Bu oturumdaki {{count}} öğe türü temel alınmıştır",
		"questionTypeRowSubtitle_zero": "Yanıtlanan öğe yok",
		"questionTypeRowSubtitle_one": "{{count}} öğe yanıtlandı",
		"questionTypeRowSubtitle_other": "{{count}} öğe yanıtlandı",
		"itemTypeDetail": {
			"review_one": "Öğeyi incele",
			"review_other": "Öğeleri incele",
			"stats": {
				"answered_one": "Öğe yanıtlandı",
				"answered_other": "Öğe yanıtlandı",
				"avgTime": "Öğe başına ort. süre"
			}
		},
		"reviewAnswersDialog": {
			"title": "Yanıtları İncele",
			"sections": {
				"skills": "Beceriler",
				"questionTypes": "Soru türleri",
				"proficiency": "Yeterlik",
				"performance": "Performans"
			},
			"summaryNone": "Devam etmek için öğe içeren filtreler seçin.",
			"summaryAll_one": "{{count}} yanıtın tamamını inceleyin.",
			"summaryAll_other": "{{count}} yanıtın tamamını inceleyin.",
			"summaryFiltered_one": "{{filters}} ile eşleşen {{count}} yanıtı inceleyin.",
			"summaryFiltered_other": "{{filters}} ile eşleşen {{count}} yanıtı inceleyin.",
			"reviewAnswers_one": "{{count}} yanıtı incele",
			"reviewAnswers_other": "{{count}} yanıtı incele",
			"more": "{{count}} tane daha"
		},
		"itemDetail": {
			"title": "Yanıtlarımı incele",
			"filterAll": "Tümü",
			"filterCorrect": "Doğru",
			"filterIncorrect": "Yanlış",
			"filterMarked": "İşaretli",
			"emptyTitle": "Eşleşen öğe yok",
			"emptyDescription": "Oturum öğelerinizin hiçbiri seçili filtreyle ({{filter}}) eşleşmiyor. Daha fazla sonuç görmek için filtreleri değiştirin veya temizleyin.",
			"emptyCta": "Filtreleri temizle"
		},
		"answerCardTitle": "Yanıtlanan öğeler",
		"answerCardSubtitle_one": "Tüm sorulardaki performansınızı görün",
		"answerCardSubtitle_other": "{{count}} sorunun tamamındaki performansınızı görün",
		"skillsBreakdown": {
			"title": "Beceri Dağılımı",
			"subtitle_one": "{{count}} öğe temel alınmıştır",
			"subtitle_other": "{{count}} öğe temel alınmıştır"
		},
		"studyPack": "Çalışma Paketi",
		"practiceTestCompleted": "Deneme sınavı tamamlandı",
		"studySessionCompleted": "Çalışma oturumu tamamlandı",
		"diagnosticSessionCompleted": "Tanılama oturumu tamamlandı",
		"timeElapsed": "Geçen süre",
		"stats": {
			"answered": "YANITLANAN",
			"time elapsed": "GEÇEN SÜRE",
			"avg speed": "ORT. HIZ",
			"hints used": "KULLANILAN İPUCU"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "Mükemmel iş—mükemmelliği hedeflemeye devam edin!",
				"highIntermediate": "Çok iyi gidiyorsunuz—güçlü yönlerinizi geliştirmeye devam edin!",
				"lowIntermediate": "İlerlemeniz istikrarlı—böyle devam!",
				"basic": "Yeteneklerinizi geliştirmek için çalışmaya devam edin!"
			},
			"infoText": "{{skillsText}} {{skills}} becerilerinizi geliştirmek için **{{numActivities}} {{activityLabel}}** tamamladınız. {{skillDetails}}. Genel olarak **{{numTotalPoints}} puandan {{numPointsEarned}} puan** kazandınız; bu da {{thisText}} {{skills}} genelinde **{{compositeLevel}}** düzeyinde bir yeterliğe işaret ediyor. {{compositeFeedback}}",
			"infoText.singleSkill": "**{{skill_1}}** becerinize odaklanan **{{itemCount}} {{itemLabel}}** tamamladınız. **{{skill_1_total}} puandan {{skill_1_score}} puan** aldınız; bu da **{{proficiency}}** düzeyinde bir yeterliğe işaret ediyor. {{compositeFeedback}}",
			"infoText.multiSkill": "**{{skills_text}}** becerilerinizi geliştirerek **{{itemCount}} {{itemLabel}}** tamamladınız. {{skill_details}} Genel olarak **{{overall_total}} puandan {{overall_score}} puan** kazandınız; bu da bu beceriler genelinde **{{overall_proficiency}}** düzeyinde bir yeterliğe işaret ediyor. {{compositeFeedback}}",
			"skillDetails": "**{{skill}}** alanında **{{total}} puandan {{score}} puan** aldınız; bu da **{{proficiency}}** düzeyinde bir yeterlik gösteriyor."
		},
		"actions": {
			"goToHome": "Ana sayfaya git",
			"studyMore": "Daha fazla çalış",
			"studyFree": "Ücretsiz {{tagTypes}} çalış",
			"reviewAnswers": "Yanıtları incele"
		},
		"nextAction": {
			"title": "Önerilen: {{focus}} alıştırması",
			"dialog": {
				"title": "Önerilen çalışma oturumu",
				"subtitle": "Eksik olduğunuz alanlara odaklanın"
			},
			"fallback": {
				"title": "Alıştırmaya devam edin",
				"description": "Sırada çalışmak istediğiniz alanlara göre bir çalışma oturumu oluşturun."
			}
		},
		"premium": {
			"upgradeCta": "Premium'a yükselt"
		},
		"disclaimer": {
			"title": "Sorumluluk reddi",
			"summativeBody": "Deneme sınavı puanları tahminidir ve gerçek bir {{examName}} sınavında aynı sonucu garanti etmez."
		},
		"performance": {
			"title": "Performans",
			"subtitle": "{{count}} öğe temel alınmıştır",
			"correct": "Doğru",
			"correctItems": "{{count}} öğe",
			"incorrect": "Yanlış",
			"incorrectItems": "{{count}} öğe"
		},
		"mastery": {
			"performanceTitle": "Performans",
			"sessionMasteryTitle": "Tahmini yeterlik",
			"subtitle_assessment": "Bu değerlendirmedeki {{count}} {{item}} temel alınmıştır",
			"subtitle_session": "Bu oturumdaki {{count}} {{item}} temel alınmıştır"
		},
		"sessionAnalysis": {
			"title": "Oturum analizi",
			"subtitle": "Kişiselleştirilmiş analiz ve öneriler",
			"viewFullAnalysis": "Analizi görüntüle",
			"feedbackDialog": {
				"body": "Neredeyse her gün güncelleme yayınlıyor ve gelişmeye kararlıyız. Geri bildirim bırakır mısınız?",
				"placeholder": "Geri bildiriminizi buraya yazın",
				"cta": "Geri bildirim gönder",
				"successMessage": "Geri bildirim gönderildi. Teşekkürler!",
				"feedbackLimitError": "Geri bildirim en az 10 karakter olmalıdır"
			},
			"menuActions": {
				"copy": "Kopyala",
				"altCopy": "Özet metnini kopyala",
				"altPositiveFeedback": "Bu yardımcı oldu",
				"positiveFeedback": "İyi yanıt",
				"negativeFeedback": "Kötü yanıt",
				"reportIssue": "Bildir",
				"altReportIssue": "Bu yanıtı bildir",
				"emailSummary": "Özet metnini e-postayla gönder",
				"emailAlreadySent": "E-posta zaten gönderildi",
				"copiedAnalysis": "Analiz panoya kopyalandı",
				"emailSent": "E-posta {{email}} adresine gönderildi. E-posta almazsanız önemsiz, spam ve son silinenler klasörlerini kontrol edin",
				"emailFailed": "{{email}} adresine e-posta gönderilemedi",
				"emailInstructionMessage": "E-posta almazsanız önemsiz, spam ve son silinenler klasörlerini kontrol edin veya BT yöneticinizle iletişime geçin"
			}
		}
	},
	"feedback": {
		"successMessage": "Geri bildirim gönderildi. Teşekkürler!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "Neyi beğendiniz? Neler geliştirilebilir? Platformu her gün iyileştiriyoruz ve ekibimiz her geri bildirimi okuyor. Teşekkürler!",
			"title": "Geri bildiriminizi paylaşın",
			"body": "Neyi beğendiniz? Neler geliştirilebilir? Platformu her gün iyileştiriyoruz ve ekibimiz her geri bildirimi okuyor. **Teşekkürler!**",
			"positiveBody": "Yardımcı olmasına sevindik! **Neyi beğendiğinizi** bize bildirin.",
			"negativeBody": "Neyin yanlış gittiğini anlamamıza yardımcı olun ki **yanıtlarımızı iyileştirebilelim.**",
			"placeholder": "Geri bildirim girin",
			"cta": "Geri bildirim gönder"
		},
		"report": {
			"title": "Bildirim gönder",
			"body": "Bu yanıtta neyin yanlış olduğunu anlamamıza yardımcı olun",
			"cta": "Bildirimi gönder"
		},
		"suggestCorrection": {
			"title": "Düzeltme öner",
			"body": "**Hataları bildirerek** bu içeriğin doğruluğunu artırmamıza yardımcı olun.",
			"cta": "Gönder"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "Hatalı",
					"description": "Yanıt yanlış bilgi içeriyor"
				},
				"notHelpful": {
					"title": "Yardımcı olmadı",
					"description": "Yanıt sorumu karşılamadı"
				},
				"incomplete": {
					"title": "Eksik",
					"description": "Yanıtta önemli ayrıntılar eksik"
				},
				"hardToUnderstand": {
					"title": "Anlaşılması zor",
					"description": "Yanıt kafa karıştırıcı veya belirsizdi"
				},
				"other": {
					"title": "Diğer",
					"description": "Başka bir şey"
				}
			},
			"report": {
				"misinformation": {
					"title": "Yanlış bilgi",
					"description": "Yanıt yanlış veya yanıltıcı bilgi içeriyor"
				},
				"harmfulContent": {
					"title": "Zararlı veya Rahatsız Edici İçerik",
					"description": "Nefret söylemi, taciz veya uygunsuz dil"
				},
				"violatesPolicies": {
					"title": "Politikaları İhlal Ediyor",
					"description": "Spam, kendini tanıtma veya yasa dışı içerik"
				},
				"other": {
					"title": "Diğer",
					"description": "Neyin yanlış gittiğini kendi cümlelerinizle anlatın"
				}
			}
		},
		"faqs": {
			"title": "Sık sorulan sorular",
			"body": "Uygulamayla ilgili en sık sorulan sorulardan bazıları aşağıdadır. Başka sorularınız varsa lütfen support@memorang.ai adresinden bize ulaşın"
		},
		"delete": {
			"title": "Hesabı sil",
			"body": "Ayrıldığınız için üzgünüz; akademik ve profesyonel yolculuğunuzda başarılar dileriz!",
			"options": "Çok pahalı|Sınavıma zaten girdim|İçeriği beğenmedim|Özellikler/işlevler eksik|Diğer",
			"confirmdelete": {
				"title": "Hesap Silmeyi Onayla",
				"cta": "Sil",
				"errorMessage": "Üzgünüz, bu e-posta bu hesapla eşleşmiyor. Lütfen tekrar deneyin",
				"successMessage": "Hesap başarıyla silindi!",
				"validEmail": "Lütfen geçerli bir e-posta adresi girin"
			}
		}
	},
	"recorder": {
		"tapToRecord": "Yanıtınızı kaydetmek için dokunun",
		"responseAudioUnavailable": "Yanıt sesi oynatma için kullanılamıyor",
		"recording": "Kaydediliyor",
		"recordingCompleted": "Kayıt Tamamlandı",
		"getReady": "Hazırlanın",
		"timeIsUp": "Süre doldu. Yanıtınız kaydedilmedi.",
		"alert": {
			"title": "Azami süreye ulaşıldı",
			"body": "Kayıt, {{maxDuration}} saniyelik azami süreye ulaştığı için durduruldu."
		},
		"uiElementPressed": "Kayıt durduruldu - kayıt sürerken uyaran açıldı."
	},
	"writing": {
		"placeholder": "Yanıtınızı buraya yazın...",
		"wordCount": "{{count}} {{word}}",
		"title": "Yanıtınız",
		"submit": "Gönder",
		"helper": {
			"range": "Yanıtınızı göndermek için {{min}}–{{max}} kelime yazın",
			"min": "Yanıtınızı göndermek için en az {{min}} kelime yazın",
			"max": "Yanıtınızı {{max}} kelime veya altına indirin"
		}
	},
	"navbar": {
		"home": "Ana sayfa",
		"progress": "İlerleme",
		"insights": "İçgörüler",
		"leaderboard": "Liderler",
		"store": "Mağaza",
		"more": "Daha fazla",
		"redeem": "Kod kullan",
		"study-pack": "Çalışma Paketi",
		"podcasts": "Podcast'ler",
		"modules": "Modüller",
		"account": "Hesap ayarları",
		"accountTab": "Hesap",
		"privacy": "Gizlilik",
		"terms": "Şartlar",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "Kodu doğru girdiniz ama sorun devam mı ediyor? **Destek ile iletişime geçin** ve erişim kodunuzu ile satın alma bilgilerinizi eklediğinizden emin olun",
		"olxDialog": {
			"unlockedTitle": "Erişim Açıldı",
			"expiredTitle": "Erişim Süresi Doldu",
			"testInfo": "**Sınav:** {{examName}} | **Test:** {{bundleName}}",
			"upcomingBody_one": "OLX testine erişiminiz açıldı!\n\nOturumunuzu **{{count}} gün** içinde başlatabilirsiniz. Oturumunuzu Deneme Testleri sekmesinden başlatmak için lütfen daha sonra tekrar kontrol edin.",
			"upcomingBody_other": "OLX testine erişiminiz açıldı!\n\nOturumunuzu **{{count}} gün** içinde başlatabilirsiniz. Oturumunuzu Deneme Testleri sekmesinden başlatmak için lütfen daha sonra tekrar kontrol edin.",
			"activeBody": "OLX testine erişiminiz artık etkin!\n\nOturumunuzu **{{date}}** tarihinden önce istediğiniz zaman başlatabilirsiniz.\n\nOturumu şimdi mi yoksa daha sonra mı başlatmak istersiniz?",
			"expiredBody": "OLX testine erişiminizin süresi **{{date}}** tarihinde doldu.\n\nDaha fazla yardım için lütfen öğretmeninizle veya okul yöneticinizle iletişime geçin.",
			"startNowCta": "Şimdi Başlat",
			"startLaterCta": "Sonra Başlat"
		},
		"unexpectedError": "Beklenmedik bir hata oluştu."
	},
	"redeemCode": {
		"titleRedeem": "Erişim Kodunu Kullan",
		"titleGranted": "Erişim Verildi",
		"formTitle": "Erişim kodunuzu girin",
		"accessCodeHint": "Erişim kodunuz varsa lütfen tireler dahil olmak üzere buraya girin.",
		"submit": "Kullan",
		"access": "Buradan erişin",
		"helpFindCode": "Kodunuzu bulmak için yardım mı gerekiyor?",
		"troubleRedeeming": "Kodu kullanırken sorun mu yaşıyorsunuz? Asistana sorun!",
		"skipStep": "Bu adımı atla"
	},
	"autoRedeem": {
		"redeem": "Kullan",
		"redeeming": "Kullanılıyor...",
		"continue": "Devam et",
		"unredeemedPrompt_one": "**{{email}}** e-posta adresiyle ilişkili, henüz kullanılmamış **{{count}} ürün** var. Hesabınıza eklemek ister misiniz?",
		"unredeemedPrompt_other": "**{{email}}** e-posta adresiyle ilişkili, henüz kullanılmamış **{{count}} ürün** var. Hesabınıza eklemek ister misiniz?",
		"successMessage_one": "Tebrikler! Aşağıdaki **ürünün** kilidi hesabınızda açıldı. Devam'a bastıktan sonra uygulamanızın içeriği şu sınavı yansıtacak şekilde değişecek: **{{examName}}**. Farklı bir sınava çalışmak veya başka bir ürün satın almak isterseniz bunu istediğiniz zaman hesap ayarlarınızdan değiştirebilirsiniz.",
		"successMessage_other": "Tebrikler! Aşağıdaki **{{count}} ürünün** kilidi hesabınızda açıldı. Devam'a bastıktan sonra uygulamanızın içeriği şu sınavı yansıtacak şekilde değişecek: **{{examName}}**. Farklı bir sınava çalışmak veya başka bir ürün satın almak isterseniz bunu istediğiniz zaman hesap ayarlarınızdan değiştirebilirsiniz."
	},
	"olxEligibility": {
		"goToPracticeTests": "Deneme sınavlarına git"
	},
	"moreChallenges": {
		"challenges": "Meydan okumalar",
		"challengesCount": "{{value}} Meydan okuma"
	},
	"tts": {
		"tooltip": "Dinle"
	},
	"commandBar": {
		"placeholder": "Ara...",
		"input": {
			"placeholder": "Komut yazın veya arayın"
		},
		"sections": {
			"quickActions": "Hızlı işlemler"
		},
		"actions": {
			"changeExam": "Sınavı değiştir",
			"switchToDarkMode": "Koyu moda geç",
			"switchToLightMode": "Açık moda geç",
			"setExamDate": "Sınav tarihi belirle"
		}
	},
	"filterView": {
		"placeholder": "Sınav ara..."
	},
	"transcript": {
		"show": "Metni göster",
		"hide": "Metni gizle"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "Uygulama Logosu",
			"testNameLabel": "Test Adı",
			"sectionLabel": "Bölüm",
			"back": "Geri dön",
			"pause": "Duraklat",
			"menuLabel": "Diğer seçenekler"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "Test ilerlemesi",
			"of": "/",
			"pauseSession": "Oturumu Duraklat",
			"timerTooltip": {
				"item": "Bu soru için kalan süre",
				"section": "Bu bölümde kalan süre",
				"test": "Bu testte kalan süre"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "İleri"
		},
		"progressBar": {
			"timeLeftLabel": "Bu soru için kalan süre",
			"timeLeftForUnit": "Bu birim için kalan süre",
			"questionOf": "Soru {{current}}/{{total}}",
			"questionProgress": "<b>{{current}}</b>/{{total}}",
			"timesUp": "Süre doldu",
			"statusTooltips": {
				"answered": "Yanıtlandı",
				"inProgress": "Devam Ediyor",
				"skipped": "Atlandı",
				"notSeen": "Görülmedi"
			}
		},
		"timeRemainingDialog": {
			"title": "Hâlâ vaktiniz var",
			"body": "Bu birimde hâlâ süre kaldı. Göndermeden önce yanıtlarınızı incelemek ister misiniz?",
			"reviewCta": "Yanıtlarımı incele"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "Kaynak",
				"answerTitle": "Yanıtınız",
				"remainingBadge": "{{count}} kaldı",
				"placedBadge": "{{count}} yerleştirildi",
				"pointsBadge": "{{earned}}/{{max}} puan",
				"emptyHint": "Paragrafları soldaki panelden buraya sürükleyin"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "Destek Bilgileri",
			"emailLabel": "E-posta",
			"subjectLabel": "Konu",
			"messageBodyLabel": "Mesaj İçeriği",
			"appDetailsLabel": "Uygulama Ayrıntıları",
			"appNameLabel": "Ad",
			"versionLabel": "Sürüm",
			"platformLabel": "Platform"
		},
		"chat": {
			"assistantTitle": "{{tenantName}} Destek Asistanı",
			"fallbackTitle": "Sohbet",
			"betaWarning": "Bu yapay zeka asistanı **Beta** aşamasındadır—yanıtlar zaman zaman hatalı veya eksik olabilir.",
			"greeting": "Merhaba 👋 Bir ürüne erişim sağlamakta sorun mu yaşıyorsunuz? Size yardımcı olmak için buradayım! Öncelikle sorunu netleştirelim. Aşağıdakilerden hangisi durumunuzu en iyi şekilde tanımlıyor?\n\n1. Bir erişim kodum var ama çalışmıyor gibi görünüyor.\n2. Satın alma yaptım ama erişim kodumu bulamıyorum.\n3. Okulum aracılığıyla erişim sağlanmış olması gerekiyordu ama erişim kodumu bulamıyorum.\n4. Daha önce bir ürüne erişimim vardı ama şu anda erişemiyorum.\n\nLütfen sorununuza karşılık gelen numarayı girin.",
			"input": {
				"label": "Bir mesaj yazın...",
				"sendLabel": "Gönder"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 Başarıyla Kullanıldı",
			"previouslyRedeemedTitle": "🚀 Daha Önce Kullanıldı",
			"subtitle": "İçeriğinize buradan erişin",
			"expires": "Son kullanma: {{date}}",
			"openCta": "Aç"
		},
		"purchases": {
			"title": "🎉 Erişim Kodları Bulundu",
			"subtitle": "İçeriğinize erişmek için kullanın",
			"accessCodesLabel_one": "Erişim Kodu",
			"accessCodesLabel_other": "Erişim Kodları",
			"moreCodes_one": "(+ {{count}} tane daha)",
			"moreCodes_other": "(+ {{count}} tane daha)",
			"featuresLabel": "Özellikler",
			"redeemCta": "Kullan"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "Yeni sürüm mevcut, güncellemek için yenile'ye tıklayın.",
			"refreshCta": "Yenile",
			"refreshA11yLabel": "Uygulamayı güncellemek için yenile",
			"dismissTooltip": "Kapat",
			"dismissA11yLabel": "Güncelleme bildirimini kapat"
		}
	},
	"cme": {
		"type": "CME Türü",
		"chooseExportMethod": "Dışa aktarma yöntemini seçin",
		"selectDateRange": "Tarih aralığını seçin",
		"from": "Başlangıç",
		"to": "Bitiş",
		"sendPdfTo": "PDF'i {{email}} adresine gönder",
		"downloadCertificate": "Sertifikayı PDF olarak indir",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "Kazanılan CME Kredisi",
		"confirmYourName": "Adınızı doğrulayın",
		"certificateNameNotice": "Bu ad, CME Sertifikanızda yazdırılacaktır.",
		"firstName": "Ad",
		"lastName": "Soyadı",
		"firstNamePlaceholder": "Adınızı girin",
		"lastNamePlaceholder": "Soyadınızı girin",
		"confirm": "Onayla",
		"creditsEarnedTitle": "Kazanılan CME",
		"creditRatioCaption": "12 Zorluk = 1 CME Kredisi",
		"earned": "Kazanıldı",
		"available": "Mevcut",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "CME Sertifikasını Dışa Aktar",
		"exportDisabledCaption": "Sertifikanızı dışa aktarmak için en az 1 CME kredisi kazanmanız gerekir",
		"viewDisclaimer": "CME Feragatını Görüntüle"
	}
}
